import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M19.626 16h-1.34l-1.13-1.58-1.12 1.58h-1.33l1.79-2.52-1.69-2.37h1.35l1.01 1.43 1.02-1.43h1.32l-1.67 2.36zm-7.35.1c-1.25 0-2.31-.8-2.5-1.91l1.07-.34c.18.66.76 1.11 1.43 1.11.71 0 1.26-.55 1.26-1.24 0-.74-.55-1.28-1.26-1.28-.44 0-.86.15-1.1.42l-1.02-.21.31-3.65h3.82v1.1h-2.77l-.16 1.61c.26-.19.68-.3 1.09-.3 1.3 0 2.29.93 2.29 2.33 0 1.32-1.09 2.36-2.46 2.36m-3.466 0c-.43 0-.77-.34-.77-.76 0-.43.34-.76.77-.76.44 0 .77.33.77.76 0 .42-.33.76-.77.76M7.36 9v7H6.2v-5.39l-1.58 1.28v-1.41L6.56 9z"
    }
  )
);
var SvgSpeed150XFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Speed150XFilled_default = SvgSpeed150XFilled;

export { Speed150XFilled_default as default };
